var ks = ks || {};

// gallery mofule
//-----------------------------------------------------------------
ks.lightGallery = function () {
  var $gallery = $(".js_lightGallery");

  if (!$gallery.length) {
    return;
  }

  //script init and parameters
  $gallery.lightGallery({
    selector: ".lightbox",
    zoom: true,
    download: false,
    enableTouch: true,
    share: false,
    actualSize: false,
    autoplay: false,
    autoplayControls: false,
    fullScreen: false,
    getCaptionFromTitleOrAlt: false,
  });
};

$(document).ready(function () {
  ks.lightGallery();
});
